import React from 'react';
import { AppBar, Menu, MenuItem, Toolbar, Typography } from '@material-ui/core';
import { IconButton } from '@material-ui/core';
import { Avatar } from '@material-ui/core';
import { LoginContext } from '../../context/LoginProvider';
// import { InputBase } from "@material-ui/core";

export default function PanelHeader() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { user, setUser } = React.useContext(LoginContext);
  const handleClose = () => {
    localStorage.removeItem('user');
    setUser(null);
    setAnchorEl(null);
  };
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  return (
    <AppBar color="inherit" position="static">
      <Toolbar variant="regular">
        <Typography variant="h5" color="textPrimary" noWrap>
          Panel de administración
        </Typography>
        <div style={{ width: '80%' }}></div>
        <div>
          <IconButton
            aria-controls="simple-menu"
            edge="end"
            onClick={handleClick}
          >
            <Avatar>{user?.username?.substring(0, 2)?.toUpperCase()}</Avatar>
          </IconButton>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            //keepMounted
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
          >
            <MenuItem onClick={handleClose}>Cerrar Sesión</MenuItem>
          </Menu>
        </div>
      </Toolbar>
    </AppBar>
  );
}
